import OutsideClickHandler from './OutsideClickHandler';
export default OutsideClickHandler;
